import React from 'react'

// components
import MobileLogoHeader from 'components/shared/LogoHeader/MobileHeader'
import MobileNav from './MobileNav'

const MobileHeader = props => {
  const { title } = props

  return <MobileLogoHeader title={title} nav={<MobileNav />} />
}

export default MobileHeader
